import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, Subscription } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as HelpActions from 'src/app/store/help/help.actions';
import { selectSubSectionCurrent, selectSubsectionModify } from 'src/app/store/help/help.selector';
import { SubSectionDataDb } from 'src/app/model/help';

@Component({
  templateUrl: './helper-add-subsection.dialog.component.html',
})

export class HelperAddSubSectionDialogComponent implements OnInit, OnDestroy {
  subsectionModifySuccess$: Observable<boolean | undefined>;
  subsectionModifySuccessSub: Subscription | undefined;
  subSectionCurrent$: Observable<SubSectionDataDb | undefined>;
  subSectionCurrentSub: Subscription | undefined;

  subSectionForm: FormGroup;
  subsection: SubSectionDataDb;
  adding = true;

  sectionId: number;
  KeyHelp: string;

  // design
  screenWidth: number;
  MIN_MD_WIDTH = 500;
  MAX_MD_WIDTH = 1120;
  MIN_WIDTH_COL4 = 1680;
  DELTA_ERROR_PIXEL = 7;
  MIN_TWO_BUTTONS_DIALOG_WIDTH = 575 + this.DELTA_ERROR_PIXEL;

  MIN_MD_WIDTH_EDIT = 600 + this.DELTA_ERROR_PIXEL;
  MIN_EXTENDED_INPUTTEXT = 750;

  constructor(
    private store: Store<AppState>,
    private ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {
    this.initSelectors();
    this.store.dispatch(HelpActions.resetSubSectionForm());
  }

  ngOnInit(): void {
    this.subscribeAll();
    this.onResize();
    if (this.config.data !== undefined && this.config.data.sectionId !== undefined) {
      this.sectionId = this.config.data.sectionId;
    }
    if (this.config.data !== undefined && this.config.data.subsectionId !== undefined) {
      this.store.dispatch(HelpActions.getHelpSubSection({ subsectionId: this.config.data.subsectionId }));
      this.adding = false;
    } else {
      this.subsection = new SubSectionDataDb();
      this.adding = true;

    }
    this.buildForm();
  }

  buildForm(): void {
    this.subSectionForm = new FormGroup({
      'KeyHelp': new FormControl(this.subsection !== undefined ? this.subsection.KeyHelp : '', Validators.required),
      'TitleIt': new FormControl(this.subsection !== undefined ? this.subsection.TitleIt : '', Validators.required),
      'TitleEn': new FormControl(this.subsection !== undefined ? this.subsection.TitleEn : '', Validators.required),
      'TitleEs': new FormControl(this.subsection !== undefined ? this.subsection.TitleEs : '', Validators.required),
      'TitleDe': new FormControl(this.subsection !== undefined ? this.subsection.TitleDe : '', Validators.required),
      'TitleFr': new FormControl(this.subsection !== undefined ? this.subsection.TitleFr : '', Validators.required),
      'TitleNl': new FormControl(this.subsection !== undefined ? this.subsection.TitleNl : '', Validators.required),
      'TitlePl': new FormControl(this.subsection !== undefined ? this.subsection.TitlePl : '', Validators.required),
      'TitleRu': new FormControl(this.subsection !== undefined ? this.subsection.TitleRu : '', Validators.required),
      'TitleSk': new FormControl(this.subsection !== undefined ? this.subsection.TitleSk : '', Validators.required),
      'User': new FormControl({ value: this.subsection !== undefined ? this.subsection.User === 1 : false, disabled: false }),
      'Technician': new FormControl({ value: this.subsection !== undefined ? this.subsection.Technician === 1 : false, disabled: false }),
      'Service': new FormControl({ value: this.subsection !== undefined ? this.subsection.Service === 1 : false, disabled: false }),
      'Guest': new FormControl({ value: this.subsection !== undefined ? this.subsection.Guest === 1 : false, disabled: false }),
      'Thermo': new FormControl({ value: this.subsection !== undefined ? this.subsection.DestinationClients.includes('com.came.thermosg') : false, disabled: false }),
      'SetUp': new FormControl({ value: this.subsection !== undefined ? this.subsection.DestinationClients.includes('com.came.crpconnectapp') : false, disabled: false }),
      'Automation': new FormControl({ value: this.subsection !== undefined ? this.subsection.DestinationClients.includes('com.came.cameconnectapp') : false, disabled: false }),
      'Access': new FormControl({ value: this.subsection !== undefined ? this.subsection.DestinationClients.includes('com.came.myaccess') : false, disabled: false }),
      'SetUpPro': new FormControl({ value: this.subsection !== undefined ? this.subsection.DestinationClients.includes('com.came.installer') : false, disabled: false }),
      'Web': new FormControl({ value: this.subsection !== undefined ? this.subsection.DestinationClients.includes('frontend') : false, disabled: false }),
    });
  }

  initSelectors(): void {
    this.subsectionModifySuccess$ = this.store.select(selectSubsectionModify);
    this.subSectionCurrent$ = this.store.select(selectSubSectionCurrent);
  }

  subscribeAll(): void {
    this.subsectionModifySuccessSub = this.subsectionModifySuccess$?.subscribe(
      (subsectionModifySuccess) => {
        if (subsectionModifySuccess) {
          this.ref.close('success');
        }
      }
    );
    this.subSectionCurrentSub = this.subSectionCurrent$.subscribe((subsectionCurrent) => {
      if (subsectionCurrent !== undefined) {
        this.subSectionCurrentSub?.unsubscribe();
        this.subsection = subsectionCurrent;
        this.buildForm();
      }
    });
  }

  ngOnDestroy(): void {
    this.subsectionModifySuccessSub?.unsubscribe();
  }

  isRowText(): boolean {
    return this.f.ContentType.value === 'text';
  }

  isRowVideo(): boolean {
    return this.f.ContentType.value === 'video';
  }

  submit(): void {
    if (this.sectionId === undefined) {
      this.sectionId = this.subsection.SectionId;
    }
    let destinationsClients = '';
    if (this.f.Thermo.value) {
      destinationsClients = destinationsClients + 'com.came.thermosg';
    }
    if (this.f.SetUp.value) {
      if (destinationsClients !== '') {
        destinationsClients = destinationsClients + ', ';
      }
      destinationsClients = destinationsClients + 'com.came.crpconnectapp';
    }
    if (this.f.Automation.value) {
      if (destinationsClients !== '') {
        destinationsClients = destinationsClients + ', ';
      }
      destinationsClients = destinationsClients + 'com.came.cameconnectapp';
    }
    if (this.f.Access.value) {
      if (destinationsClients !== '') {
        destinationsClients = destinationsClients + ', ';
      }
      destinationsClients = destinationsClients + 'com.came.myaccess';
    }
    if (this.f.SetUpPro.value) {
      if (destinationsClients !== '') {
        destinationsClients = destinationsClients + ', ';
      }
      destinationsClients = destinationsClients + 'com.came.installer';
    }
    if (this.f.Web.value) {
      if (destinationsClients !== '') {
        destinationsClients = destinationsClients + ', ';
      }
      destinationsClients = destinationsClients + 'frontend';
    }
    this.subsection = {
      ...this.subsection,
      SectionId: this.sectionId,
      KeyHelp: this.f.KeyHelp.value,
      TitleIt: this.f.TitleIt.value,
      TitleEn: this.f.TitleEn.value,
      TitleEs: this.f.TitleEs.value,
      TitleDe: this.f.TitleDe.value,
      TitleFr: this.f.TitleFr.value,
      TitleNl: this.f.TitleNl.value,
      TitlePl: this.f.TitlePl.value,
      TitleRu: this.f.TitleRu.value,
      TitleSk: this.f.TitleSk.value,
      User: this.f.User.value ? 1 : 0,
      Technician: this.f.Technician.value ? 1 : 0,
      Service: this.f.Service.value ? 1 : 0,
      Guest: this.f.Guest.value ? 1 : 0,
      DestinationClients: destinationsClients,
    };
    if (this.subsection.Id) {
      this.store.dispatch(HelpActions.editHelpSubSection({ subsection: this.subsection }));
    } else {
      this.store.dispatch(HelpActions.addHelpSubSection({ subsection: this.subsection }));
    }
  }

  get f(): any {
    return this.subSectionForm.controls;
  }

  closeDialog(): void {
    this.ref.close();
  }

  // Design
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenWidth = window.innerWidth;
  }

  onMobileEdit(): boolean {
    return (this.screenWidth <= this.MIN_MD_WIDTH_EDIT);
  }

  col12Responsive(): string {
    return (this.screenWidth <= this.MIN_MD_WIDTH) ? "col-6" : "col-3";
  }

  dynamicAutocomplete(): string {
    if (this.onMobileEdit()) {
      return "p-autocomplete-panel";
    }
    return "p-autocomplete-panel-right";
  }

  dynamicButtonWidth(): string {
    return (this.screenWidth <= this.MIN_TWO_BUTTONS_DIALOG_WIDTH) ? "w-full" : "w-16rem";
  }
  dynamicInputTextHeight(): string {
    return (this.onMobileEdit()) ? "h-2_5rem" : "h-2rem";
  }

  justifyContentStyle(): string {
    return this.onMobileEdit() ? "justify-content-center" : "justify-content-start";
  }

  // Errors management & Design Border | Input
  showErrorInvalidMessage(type: HelperAddSubSectionDialogComponent["f"]): boolean {
    return (type.errors !== null) && (type.errors !== undefined) && (type.dirty);
  }

  showErrorConfirmInvalidMessage(type: HelperAddSubSectionDialogComponent["f"], notEquivalentType: string): boolean {
    return ((type.errors !== null && type.errors !== undefined && type.dirty) || (this.subSectionForm.errors !== null && this.subSectionForm.errors[notEquivalentType] !== null && this.subSectionForm.errors[notEquivalentType] && type.dirty));
  }

  showErrors(type: HelperAddSubSectionDialogComponent["f"], classType: string): string {
    let inputTextStyle = "";

    switch (classType) {
      case 'borderRow':
        if (this.onMobileEdit()) {
          return "row";
        }
        return ((type.errors !== null) && (type.dirty)) ? "border-bottom-1 border-50" : "border-bottom-1 border-100";
      case 'borderInput':
        if (this.onMobileEdit()) {
          inputTextStyle += "col-12 w-full p-0";
        }
        if ((type.errors !== null) && (type.dirty)) {
          inputTextStyle += " border-bottom-1 border-50";
        } else {
          inputTextStyle += " border-bottom-1 border-100";
        }
        return inputTextStyle;
      case 'label':
        if (this.onMobileEdit()) {
          inputTextStyle += "col-12 p-1";
        }
        if ((type.errors !== null) && (type.dirty)) {
          inputTextStyle += " text-50";
        }
        return inputTextStyle;
      default:
        return inputTextStyle;
    }
  }

  showErrorsConfirmFields(type: HelperAddSubSectionDialogComponent["f"], classType: string, notEquivalentType: string): string {
    let inputTextStyle = "";

    switch (classType) {
      case 'borderRow':
        if (this.onMobileEdit()) {
          return "row";
        }
        if ((type.errors !== null && type.dirty) || (this.subSectionForm.errors !== null && this.subSectionForm.errors[notEquivalentType] !== null && this.subSectionForm.errors[notEquivalentType] && type.dirty)) {
          inputTextStyle += " border-bottom-1 border-50";
        } else {
          inputTextStyle += " border-bottom-1 border-100";
        }
        return inputTextStyle;
      case 'borderInput':
        if (this.onMobileEdit()) {
          inputTextStyle += "col-12 w-full p-0";
        }
        if ((type.errors !== null && type.dirty) || (this.subSectionForm.errors !== null && this.subSectionForm.errors[notEquivalentType] !== null && this.subSectionForm.errors[notEquivalentType] && type.dirty)) {
          inputTextStyle += " border-bottom-1 border-50";
        } else {
          inputTextStyle += " border-bottom-1 border-100";
        }
        return inputTextStyle;
      case 'label':
        if (this.onMobileEdit()) {
          inputTextStyle += "col-12 p-1";
        }
        if ((type.errors !== null && type.dirty) || (this.subSectionForm.errors !== null && this.subSectionForm.errors[notEquivalentType] !== null && this.subSectionForm.errors[notEquivalentType] && type.dirty)) {
          inputTextStyle += " text-50";
        }
        return inputTextStyle;
      default:
        return inputTextStyle;
    }
  }

  showErrorRequiredMessage(type: HelperAddSubSectionDialogComponent["f"]): boolean {
    return (type.errors !== null) && (type.dirty);
  }

  col4Responsive(fieldPosition: string): string {
    if (this.screenWidth >= this.MIN_WIDTH_COL4) {
      if (fieldPosition === 'left') {
        return "col-12 pl-6 pr-3";
      }
      if (fieldPosition === 'center') {
        return "col-12 px-5";
      }
      if (fieldPosition === 'right') {
        return "col-12 pl-3 pr-6";
      }
      return "col-12";
    } else {
      return (this.screenWidth >= this.MAX_MD_WIDTH) ? "col-12 px-12" : "col-12";
    }
  }
  dynamicInputTextFormat(classType: string): string {
    switch (classType) {
      case 'borderRow':
        if (this.screenWidth <= this.MIN_EXTENDED_INPUTTEXT) {
          return "row";
        }
        return "";
      case 'borderInput':
        if (this.screenWidth <= this.MIN_EXTENDED_INPUTTEXT) {
          return "col-12 w-full p-0";
        }
        return "";
      case 'label':
        if (this.screenWidth <= this.MIN_EXTENDED_INPUTTEXT) {
          return "col-12 p-1";
        }
        return "";
      case 'inputText':
        if (this.screenWidth <= this.MAX_MD_WIDTH) {
          if (this.screenWidth <= this.MIN_EXTENDED_INPUTTEXT) {
            return "w-full h-2_5rem"
          }
          return "w-20rem h-2rem";
        }
        return "w-13rem h-2rem";
      default:
        return "";
    }
  }
  marginResponsive(): string {
    return (this.screenWidth > this.MAX_MD_WIDTH) ? "mr-2_5rem" : "";
  }
}
